module.exports = __webpack_public_path__ + "img/item-options-button.bd35afc8.svg";